/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getVersion } from '../fn/version/get-version';
import { GetVersion$Params } from '../fn/version/get-version';
import { VersionResponse } from '../models/version-response';


/**
 * Returns the current application version.
 */
@Injectable({ providedIn: 'root' })
export class VersionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getVersion()` */
  static readonly GetVersionPath = '/version';

  /**
   * Returns the current application version.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVersion$Response(params?: GetVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<VersionResponse>> {
    const obs = getVersion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Returns the current application version.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVersion(params?: GetVersion$Params, context?: HttpContext): Observable<VersionResponse> {
    const resp = this.getVersion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VersionResponse>): VersionResponse => r.body)
    );
  }

}
